import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

export const StyledSpotlightExpert = styled.div`
  flex: 1;
  display: flex;

  ${MediaQueries.mbUp} {
    margin: 0 0 48px 0;
  }

  &[data-is-single-expert='false'] {
    ${MediaQueries.mbDown} {
      flex-direction: column;
      text-align: center;
      align-items: center;
      gap: 8px;
    }
  }
`
export const StyledExpertAvatar = styled.div`
  position: relative;
  width: max-content;
  height: max-content;
  display: flex;
  margin-right: 8px;

  img {
    border-radius: 50%;
  }
  .avatar {
    object-fit: cover;
  }
  .badge {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 24px;
    height: 24px;
  }
`

export const StyledExpertInfo = styled.div`
  &[data-is-single-expert='true'] {
    ${MediaQueries.mbDown} {
      margin: auto 0;
    }
  }

  .name {
    font-weight: 600;
  }
`
